import { createService, z } from '@betty/toolkit/api';

const LandingPromo = z.object({
  title: z.string(),
  promoType: z.string(),
  subPromoType: z.string(),
  bannerImageUrl: z.string().url(),
  shortDescription: z.string(),
  longDescription: z.string(),
  termsAndConditions: z.string(),
  subTypeMeta: z.object({
    minimumQualificationAmount: z.number(),
  }),
  rewards: z.array(
    z.object({
      rewardTarget: z.string(),
      rewardAmount: z.number(),
    }),
  ),
  slug: z.string().optional(),
});

export const LandingPromosResponseSchema = z.object({
  promotions: z.array(LandingPromo),
});

export type LandingPromoType = z.infer<typeof LandingPromo>;

export default createService({
  getLandingPromos: {
    method: 'GET',
    url: '/Lobby/promotions/landing',
    responseSchema: LandingPromosResponseSchema,
  },
});
